import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f577d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pwd" }
const _hoisted_2 = { class: "tips" }
const _hoisted_3 = { style: {"margin":"16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$t('me.setPass'),
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("me.setpasstips")), 1 /* TEXT */),
      _createVNode(_component_van_form, {
        onSubmit: $setup.onSubmit,
        "label-width": "70px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withCtx(() => [
              _createCommentVNode(" 旧密码 "),
              ($setup.jumpType != '1')
                ? (_openBlock(), _createBlock(_component_van_field, {
                    key: 0,
                    maxlength: "20",
                    name: "oldPassword",
                    modelValue: $setup.oldPassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.oldPassword) = $event)),
                    type: "password",
                    clearable: "",
                    label: $setup.t('me.oldPassword'),
                    placeholder: $setup.t('me.inputOldPassword'),
                    rules: [{ required: true, message: $setup.t('me.inputOldPassword') }]
                  }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder", "rules"]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" 新密码 通过 pattern 进行正则校验 "),
              _createVNode(_component_van_field, {
                maxlength: "20",
                name: "password",
                modelValue: $setup.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.password) = $event)),
                type: "password",
                clearable: "",
                label: $setup.t('me.newPassword'),
                placeholder: $setup.t('me.inputpassword'),
                rules: [{ pattern: $setup.pattern, message: $setup.t('me.inputpassword') }]
              }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder", "rules"]),
              _createCommentVNode(" 再次输入新密码 "),
              _createVNode(_component_van_field, {
                maxlength: "20",
                name: "password2",
                modelValue: $setup.password2,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.password2) = $event)),
                type: "password",
                clearable: "",
                label: $setup.t('me.querenpwd'),
                placeholder: $setup.t('me.inputpasswordagain'),
                rules: [{
              validator: (value) => { return $setup.password == value },
              message: $setup.t('me.inputpasswordagain')
            }]
              }, null, 8 /* PROPS */, ["modelValue", "label", "placeholder", "rules"])
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("me.ok")), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}